import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SubBarrioModel } from '../../models/sub-barrio.model';
import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root'
})
export class SubBarriosService extends BaseService<SubBarrioModel> {

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.tipo = 'Sub-barrio';
    this.urlBase = `${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.subBarrio}`;
   }

   getByBarrio(idBarrio: number): Observable<SubBarrioModel[]> {
    return this.httpClient.get<SubBarrioModel[]>(`${environment.baseApi}${environment.endPoints.maestras.base_maestra}${environment.endPoints.maestras.barrio}/${idBarrio}${environment.endPoints.maestras.subBarrio}`);
   }
}
